'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _frontendUtils = require('@import/frontend-utils');
var _validationUtils = require('@import/validation-utils');
var ValidationUtils = _interopRequireWildcard(_validationUtils);
var _BaseApi2 = require('../BaseApi');
var _BaseApi3 = _interopRequireDefault(_BaseApi2);
var _ParameterError = require('../ParameterError');
var _ParameterError2 = _interopRequireDefault(_ParameterError);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var EmailVerificationApi = function (_BaseApi) {
  (0, _inherits3.default)(EmailVerificationApi, _BaseApi);
  function EmailVerificationApi() {
    (0, _classCallCheck3.default)(this, EmailVerificationApi);
    return (0, _possibleConstructorReturn3.default)(this, (EmailVerificationApi.__proto__ || Object.getPrototypeOf(EmailVerificationApi)).call(this, _frontendUtils.endpoints.emailVerificationBaseUrl));
  }

  /**
   * Sends the current auth user an email with a link to verify their email address
   * @return {Promise} Promise resolves with user details object, if query finished successfully. Otherwise promise rejects with ResponseError object.
   */

  (0, _createClass3.default)(EmailVerificationApi, [{
    key: 'sendEmail',
    value: function sendEmail(newEmail) {
      return this.makeRequest({
        method: 'GET',
        url: 'sendemail',
        queryParameters: {
          newemail: newEmail
        },
        responseTransformers: {
          'application/json': function applicationJson() {
            return {};
          }
        }
      });
    }
  }, {
    key: 'verifyToken',
    value: function verifyToken(token) {
      if (!ValidationUtils.isNonEmptyOrBlankString(token)) {
        return Promise.reject(new _ParameterError2.default('token', token, 'token string.'));
      }
      return this.makeRequest({
        method: 'POST',
        url: 'verifytoken',
        responseTransformers: {
          'application/json': function applicationJson() {
            return {};
          }
        },
        body: {
          token: token
        }
      });
    }
  }, {
    key: 'verifyEduEmail',
    value: function verifyEduEmail(email) {
      if (!ValidationUtils.isNonEmptyOrBlankString(email)) {
        return Promise.reject(new _ParameterError2.default('email', email, 'email string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: 'verifyeduemail',
        queryParameters: {
          email: email
        },
        responseTransformers: {
          'application/json': function applicationJson() {
            return {};
          }
        }
      });
    }
  }]);
  return EmailVerificationApi;
}(_BaseApi3.default);
exports.default = EmailVerificationApi;